import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { CrmLearningProfile, CrmLearningProfileAccessGate } from '@features/crm-learning-profiles';
import { firstAccessibleCrmCustomerRecordArea } from '@widgets/crm-customer-record-shell';

const educationModuleLogSearchSchema = z.object({
  educationModuleLogProfileTab: z.string().optional(),
});

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/learning/education-module-logs/$educationModuleLogId'
)({
  component: EducationModuleLogProfileRoute,
  validateSearch: educationModuleLogSearchSchema,
});

function EducationModuleLogProfileRoute() {
  const navigate = Route.useNavigate();
  const { userProfileId: customerId, educationModuleLogId, locale } = Route.useParams();

  return (
    <main className="min-w-0 p-4 sm:p-6">
      <CrmLearningProfileAccessGate
        customerId={customerId}
        onAccessUnavailable={(allowedAreas) => {
          const fallback = firstAccessibleCrmCustomerRecordArea(allowedAreas);
          return (
            <Navigate
              params={{ userProfileId: customerId, locale }}
              replace
              to={fallback?.route ?? '/$locale/unauthorized'}
            />
          );
        }}
      >
        {(viewerAccessScope) => (
          <CrmLearningProfile
            activeTab="general"
            customerId={customerId}
            kind="em-log"
            locale={locale}
            profileId={educationModuleLogId}
            viewerAccessScope={viewerAccessScope}
            onBack={() => {
              void navigate({
                to: '/$locale/crm/user-profiles/$userProfileId/learning',
                params: { userProfileId: customerId, locale },
                search: (current: Record<string, unknown>) => {
                  const learningSearch = { ...current };
                  delete learningSearch.educationModuleLogProfileTab;
                  return learningSearch;
                },
              });
            }}
            onTabChange={() => undefined}
          />
        )}
      </CrmLearningProfileAccessGate>
    </main>
  );
}
